<template>
  <div class="space-y-2">
    <div class="flex items-center justify-between"><ConfigHelpLabel label="社交链接" help-key="block_social_links" label-class="text-[10px] text-gray-500" tag="span" /><button @click="addLink" class="text-[10px] text-blue-600 hover:text-blue-800">+ 添加</button></div>
    <div v-for="(lnk, idx) in block.data.links" :key="idx" class="flex gap-1 items-center">
      <select v-model="lnk.platform" @change="$emit('update')" class="w-20 px-1 py-1 border border-gray-300 rounded text-xs">
        <option value="facebook">Facebook</option><option value="instagram">Instagram</option><option value="twitter">X/Twitter</option>
        <option value="youtube">YouTube</option><option value="tiktok">TikTok</option><option value="linkedin">LinkedIn</option>
      </select>
      <input v-model="lnk.url" @input="$emit('update')" placeholder="链接" class="flex-1 px-2 py-1 border border-gray-300 rounded text-xs" />
      <button @click="removeLink(idx)" class="text-red-400 hover:text-red-600 text-[10px]">✕</button>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from 'vue'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String] })
const emit = defineEmits(['update'])
onMounted(() => { if (!props.block.data) props.block.data = { links: [] }; if (!props.block.data.links) props.block.data.links = [] })
function addLink() { props.block.data.links.push({ platform: 'facebook', url: '' }); emit('update') }
function removeLink(idx) { props.block.data.links.splice(idx, 1); emit('update') }
</script>
